<div class="funfacts-and-feedback-area ptb-100" *ngFor="let Image of bgImage;" style="background-image: url({{Image.img}});">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="feedback-content">
                    <span class="sub-title">cosa dicono di noi</span>
                    <h2>Raggiungi i tuoi obiettivi con Master&Professioni</h2>
                    <p>Puoi studiare quando e dove vuoi. Abbiamo studenti in tutta Italia e una reputazione globale come pionieri nel campo dell'apprendimento flessibile. Il nostro insegnamento significa anche che, se viaggi spesso o devi trasferirti, puoi continuare a seguire i corsi ovunque tu vada.</p>
                    <div class="feedback-slides">
                        <owl-carousel-o [options]="feedbackSlides">
                            <ng-template carouselSlide>
                                <div class="single-feedback-item">
                                    <p>La nostra innovativa didattica in modalità e-learning è progettata per offrire un'apprendimento coinvolgente e flessibile. Con corsi accessibili da qualsiasi luogo e dispositivi vari, gli studenti possono imparare a proprio ritmo. Utilizziamo risorse multimediali, tutoraggio online e interattività per garantire un'esperienza educativa di qualità superiore. Investiamo nella vostra crescita professionale, rendendo l'apprendimento conveniente e adattabile alle vostre esigenze.</p>
                                </div>
                            </ng-template>
                            <ng-template carouselSlide>
                                <div class="single-feedback-item">
                                    <p>I nostri corsi sono guidati da un team di tutor certificati CompTIA e esperti del settore altamente qualificati. La loro vasta esperienza e conoscenza approfondita garantiscono un apprendimento di alto livello. I nostri tutor sono dedicati a guidarti lungo il percorso dell'educazione, offrendo supporto personalizzato e condividendo le migliori pratiche del settore. Prepara il terreno per il successo con l'assistenza di professionisti esperti che ti aiuteranno a raggiungere i tuoi obiettivi educativi e professionali.</p>
                                </div>
                            </ng-template>
                            <ng-template carouselSlide>
                                <div class="single-feedback-item">
                                    <p>I nostri honeypot sono una componente essenziale della nostra strategia di sicurezza informatica. Sono sistemi progettati per attirare e rilevare attività sospette o minacce cibernetiche, aiutando a proteggere i vostri dati e i vostri sistemi. Grazie ai nostri honeypot altamente sofisticati e personalizzati, monitoriamo costantemente il panorama delle minacce digitali e intraprendiamo azioni preventive per garantire la sicurezza dei vostri assets digitali. Contate su di noi per una difesa proattiva e affidabile contro le minacce online.</p>
                                </div>
                            </ng-template>
                            <ng-template carouselSlide>
                                <div class="single-feedback-item">
                                    <p>I nostri stage con professionisti sono un'opportunità unica per arricchire il tuo percorso di studio. Collaboriamo con esperti del settore che ti guideranno attraverso un'esperienza pratica e concreta. Durante il tuo percorso di formazione, avrai l'opportunità di lavorare a stretto contatto con professionisti esperti che condividono la loro vasta conoscenza e competenza.</p>
                                </div>
                            </ng-template>
                        </owl-carousel-o>
                    </div>
                    <div class="feedback-info">
                        <p>Non sei ancora registrato?​ <a routerLink="/contatti">Registrati adesso</a></p>
                        <p>Password dimenticata?​ <a routerLink="/contatti">Reset Password</a></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="funfacts-list">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-funfacts-box">
                                <h3><span [countUp]="4000">00</span>+</h3>
                                <p>Studenti Iscritti nel circuito di partnership universitaria</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-funfacts-box">
                                <h3><span [countUp]="3000">00</span>+</h3>
                                <p>Classi Completate nel circuito di partnership universitaria</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-funfacts-box">
                                <h3><span [countUp]="92">00</span>%</h3>
                                <p>Studenti con riscontri lavorativi nel circuito di partnership universitaria</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-funfacts-box">
                                <h3><span [countUp]="500">00</span>+</h3>
                                <p>Corsi con punteggi per concorsi nel circuito di partnership universitaria</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <app-video></app-video>
            </div>
        </div>
    </div>
    <div class="shape2"><img src="assets/img/shape2.png" alt="image"></div>
    <div class="shape3"><img src="assets/img/shape3.png" alt="image"></div>
    <div class="shape4"><img src="assets/img/shape4.png" alt="image"></div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>
